<template>
    <authenticated-layout>
        <v-card class="pa-6">
            <v-card-title
                class="d-flex justify-space-between align-center pa-0 pb-2"
            >
                <span>
                    {{ $t("offersCreate.Create a new offer") }}
                </span>

                <v-btn
                    variant="flat"
                    size="small"
                    color="primary"
                    :href="`/customers/${customer.id}`"
                >
                    {{ $t("offersCreate.Return") }}
                </v-btn>
            </v-card-title>

            <div class="mt-6">
                <common-options
                    :offerBasis="offerBasis"
                    :roofSheathings="roofSheathings"
                    :extraCosts="extraCostsModel"
                    :price-factors="priceFactors"
                    :currency-symbol="currencySymbol"
                    :subsidy-model="subsidyModel"
                    :financing-model="financingModel"
                />

                <div :class="countryConfig.divClasses">
                    <sample-pv-offer
                        v-for="index in countryConfig.count"
                        :key="index"
                        :offerBasis="offerBasis"
                        :allSolarPanels="allSolarPanels"
                        :allInverters="allInverters"
                        :allBatteries="allBatteries"
                        :defaultInverterId="defaultInverters[index - 1]"
                        :defaultSolarPanelId="defaultPanels[index - 1]"
                        :roofSheathings="roofSheathings"
                        :pricing-factors="priceFactors"
                        :minimum-company-margins="minimumCompanyMargins"
                        :base-margins="baseMargins"
                        :sample-pv-offer-index="index"
                        :locale="locale"
                        :auth-user="authUser"
                        :annual-consumption="customer.annual_kwh_consumption"
                        :extraCosts="extraCostsModel"
                        :subsidy-model="subsidyModel"
                        :financing-model="financingModel"
                    />
                </div>
            </div>
        </v-card>
    </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated";
import CommonOptions from "@/Components/Offer/CommonOptions";
import SamplePvOffer from "../../Components/Offer/SamplePvOffer";
import { ref } from 'vue'
import SubsidyModel from "@/models/SubsidyModel";
import FinancingModel from "@/models/FinancingModel";

export default {
    props: {
        allSolarPanels: {
            type: Array,
            required: true,
        },
        allInverters: {
            type: Array,
            required: true,
        },
        allBatteries: {
            type: Array,
            required: true,
        },
        customer: {
            type: Object,
            required: false,
        },
        defaultPanels: {
            type: Array,
            required: true,
        },
        defaultInverters: {
            type: Array,
            required: true,
        },
        roofSheathings: {
            type: Array,
            required: true,
        },
        priceFactors: {
            type: Array,
            required: true,
        },
        extraCosts: {
            type: Array,
            required: true,
        },
        minimumCompanyMargins: {
            type: Array,
            required: true,
        },
        baseMargins: {
            type: Array,
            required: true,
        },
        locale: {
            type: String,
            required: true,
        },
        authUser: {
            type: Object,
            required: true,
        },
        activeSubsidy: {
            type: Object,
            required: false,
            default: () => null
        },
        financingOptions: {
            type: Object,
            required: false,
            default: () => null
        },
        currencySymbol: {
            type: String,
            required: true,
        },
        titleNoSubsidy: {
          type: String,
          required: false,
          default: () => 'No subsidy'
        },
    },
    components: {
        SamplePvOffer,
        CommonOptions,
        AuthenticatedLayout,
    },
    data() {
        return {
            offerBasis: {
                roof_sheathing: 1,
                lightning_protection: false,
                grounding: false,
                digging: false,
                digging_length: 0,
                lift: false,
                stuck_tiles: false,
                snow_guards: false,
                lightning_rod_removal: false,
                insurance: false,
                imageUpload: null,
                annualConsumption: this.customer.annual_kwh_consumption,
                clientName: this.customer ? this.customer.name : "",
                clientAddress: this.customer ? this.customer.address : "",
                pdId: this.customer ? this.customer.pd_id : null,
                mpSubsidy: false,
                vat_level: process.env.MIX_APP_LOCALE === "pl" ? 1.08 : 1.06,
                // discountAvailable: false
            },
        };
    },
    setup(props) {
        const extraCostsData = props.extraCosts.map((o) => ({
            id: o.id,
            name: o.name,
            price: parseFloat(o.price),
            selected: false
        }));

        const extraCostsModel = ref(extraCostsData)

        let subsidyModel;

        if (props.activeSubsidy === null) {
            subsidyModel = null;
        } else {
            subsidyModel = ref(new SubsidyModel({
              activeSubsidy: props.activeSubsidy,
              titleNoSubsidy: props.titleNoSubsidy,
            }))
        }
        let financingModel = ref(new FinancingModel(props.financingOptions))

        return { extraCostsModel, subsidyModel, financingModel }
    },
    computed: {
        countryConfig() {
            switch (process.env.MIX_APP_LOCALE) {
                case "pl":
                    return {
                        divClasses: "grid sm:grid-cols-2 lg:grid-cols-3 gap-3 pt-4",
                        count: 3,
                    };
                case "nl":
                    return {
                        divClasses: "grid sm:grid-cols-2 gap-3 pt-4",
                        count: 2,
                    };
            }
        },
    },
    methods: {},
};
</script>
